import React, { useContext, useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';
import { 
    TextField, 
    Button, 
    Box, 
    Typography, 
    Alert, 
    Container,
    Link
} from '@mui/material';

const ResetPassword = () => {
  const { resetPassword } = useUser();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState(''); // Password confirmation
  const [error, setError] = useState(''); 
  const [passwordError, setPasswordError] = useState(''); // Password confirmation error
  const [message, setMessage] = useState(''); 
  const [token, setToken] = useState(''); // Password reset token
  const [searchParams] = useSearchParams();

  // Handle the form submission for login, registration, or forgot password
  const handleReset = async() => {

    setError(''); // Clear error if validation passes

    // Validate passwords for registration
    if (password !== confirmPassword) {
      setPasswordError('Passwords do not match.');
      return;
    }

    try {
      await resetPassword(token, password);
      setMessage('Password reset successfully! Return to Login');
    }catch (err: any) {
      if(err.status === 401 || err.status === 422){
        setError(err.data.message);
      }else {
        setError('An error occurred. Please try again later.');
      }
    }
  };


  // Handle Enter key for form submission
  const handleKeyPress = (e: any) => {
    if (e.key === 'Enter') {
      handleReset()
    }
  };

  useEffect(() => {
    setToken(searchParams.get('token') || '');
  }, []);

  return (
    <Container maxWidth="sm">
      <Box
        component="form"
        onSubmit={(e) => {
          e.preventDefault();
          handleReset();
        }}
        sx={{ 
          mt: 8, 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center',
          backgroundColor: 'background.paper',
          padding: 3,
          borderRadius: 2,
          boxShadow: 3
        }}
      >

        <Typography component="h1" variant="h5">
          Reset Password
        </Typography>

        {/* Error Alert */}
        {error && <Alert severity="error" sx={{ mt: 2, width: '100%' }}>{error}</Alert>}
        {message && <Alert severity="info" sx={{ mt: 2, width: '100%' }}>{message}</Alert>}

        <Box sx={{ mt: 3, width: '100%' }}>
          <TextField
            variant="outlined"
            margin="normal"
            fullWidth
            label="Password"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyPress={handleKeyPress}
            error={!!error && !password}
            helperText={error && !password ? 'Password is required.' : ''}
          />

          {/* Confirm Password for Registration */}
          <TextField
            variant="outlined"
            margin="normal"
            fullWidth
            label="Confirm Password"
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            onKeyPress={handleKeyPress}
            error={!!passwordError}
            helperText={passwordError}
          />

        </Box>

        {/* Submit Button */}
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          sx={{ mt: 2, mb: 2 }}
        >
          Reset Password
        </Button>

        <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
          <Link href="/login" variant="body2">
            Return to Login
          </Link>
        </Box>
      </Box>
    </Container>
  );
};

export default ResetPassword;
